import styles from './index.module.scss';

import { Input } from 'antd';
const Xinput = ({ value, onChange, min, max }: any) => {
  return (
    <div className={styles.Xinput}>
      <div
        className={styles.itemBox_left}
        onClick={e => {
          e.stopPropagation();
          if (value > 0) {
            onChange(min ? Math.max(min, value - 1) : value - 1);
          }
        }}
        // style={{ cursor: value > 0 ? 'pointer' : 'not-allowed', opacity: value > 0 ? 1 : 0.5 }}
      >
        -
      </div>
      <div className={styles.contentBox}>
        <Input
          variant="borderless"
          value={value}
          onChange={e => {
            e.stopPropagation();
            onChange && onChange(e);
          }}></Input>
      </div>
      <div
        className={styles.itemBox_right}
        style={{ background: `#0A287D`, color: `#ffffff` }}
        onClick={() => {
          onChange(max ? Math.min(value + 1, max) : value + 1);
        }}>
        +
      </div>
    </div>
  );
};

export default Xinput;
